import React from 'react';
import { Box, Button, Theme, Typography, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { ThemeProvider, createStyles, makeStyles, useTheme } from '@material-ui/styles';

import { MainTheme } from 'src/theme';

import ScreenhubLogo from '../../assets/screenhub_logo.png';

const useStyles = makeStyles<Theme>(theme => {
  return createStyles({
    dialogPaper: {
      maxWidth: '584px',
    },
    bannerImage: {
      width: '230px',
    },
    title: {
      fontWeight: 700,
      color: '#1d2026',
      fontSize: '24px',
      fontStyle: 'normal',
      lineHeight: 'normal',
    },
    textBox: {
      width: '410px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
    },
    dialogActionArea: {
      backgroundColor: '#ffffff',
      padding: '8px 80px 40px 80px'
    },
    contentBox: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '536px',
      gap: '24px',
    },
    context: {
      fontWeight: 400,
      color: '#1d2026',
      textAlign: 'center',
      fontSize: '16px',
      fontStyle: 'normal',
      lineHeight: 'normal',
    },
    startButton: {
      padding: '8px 22px',
      textTransform: 'none'
    },
  });
});

const WelcomeDialog: React.FC<{ onStart: () => void }> = ({ onStart }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <ThemeProvider theme={MainTheme}>
      <Dialog
        open
        fullWidth
        maxWidth="sm"
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent
          className={classes.dialogContent}
          style={{
            backgroundColor: '#ffffff',
            paddingTop: '40px',
            paddingBottom: '24px'
          }}
        >
          <Box className={classes.contentBox}>
            <img
              src={ScreenhubLogo}
              alt="Welcome"
              className={classes.bannerImage}
            />
            <Box className={classes.textBox}>
              <Typography variant="h5" className={classes.title}>Welcome to ScreenHub !</Typography>
              <Typography variant="body1" className={classes.context}>
                Click "Next" to share some details about your business so we can better tailor our services to meet your needs.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions className={classes.dialogActionArea}>
          <Button
            variant="contained"
            color="primary"
            onClick={onStart}
            fullWidth
            className={classes.startButton}
          >
            Next
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default WelcomeDialog;